export enum PermitableTypes {
  LmsProfile = 'LmsProfile',
  Course = 'Course',
}
